// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jO2t","left":"styles_left__Oowm8"};